import Vue from 'vue'
import authorization from '@/utils/authorization'

function sortByColor (a, b) {
  if (a.color === b.color) return 0
  if (a.color === 'red' && b.color !== 'red') return -1
  if (a.color === 'orange' && b.color === 'blue') return -1
  if (a.color === 'orange' && b.color === 'gray') return -1
  if (a.color === 'blue' && b.color === 'gray') return -1
  return 1
}

function sortByAlarmAt (a, b) {
  if (a.lastAlarmAt && b.lastAlarmAt) return new Date(b.lastAlarmAt) - new Date(a.lastAlarmAt)
  return new Date(b.alarmAt) - new Date(a.alarmAt)
}

function topColor (a, b) {
  if (a === 'red' || b === 'red') return 'red'
  if (a === 'orange' || b === 'orange') return 'orange'
  if (a === 'blue' || b === 'blue') return 'blue'
  if (a === 'gray' || b === 'gray') return 'gray'
  return b
}

// initial state
const state = {
  alarms: [
    // {
    //   id: '52DAA98D-E565-4E38-B390-7EB72EB51E80',
    //   realEstateID: '5250',
    //   categoryID: 'kommunikation',
    //   category: 'Kommunikation',
    //   systemID: 'opto22',
    //   system: 'Opto22',
    //   message: 'Ej komplett CSV log',
    //   color: 'orange',
    //   type: 'B', // A=red, B=orange, C=blue
    //   hasInfo: false,
    //   // info: 'En liten notering bara',
    //   hasLinks: false,
    //   links: [
    //     // { title: 'HUB', url: 'https://fabege.hubapp.org' }
    //   ],
    //   alarmCount: 1,
    //   alarmAt: '2019-06-13T09:45:34+01:00',
    //   hasDedu: false
    //   // deduID: '220',
    //   // deduColor: 'red'
    // }
  ]
}

// getters
const getters = {
  all: state => state.alarms.filter(alarm => alarm.alarmCount > 0).sort(sortByColor),
  find: (state, getters) => (id) => getters.all.find(alarm => alarm.id === id),
  byRealEstate: (state, getters) => (realEstate, groupBy) => {
    const grouped = {}
    getters.all.filter(a => a.realEstateID === realEstate.id).sort(sortByAlarmAt).reverse().forEach(alarm => {
      let key = alarm[groupBy]
      let groupAlarm = grouped[key] || { alarmCount: 0, alarmCountA: 0, alarmCountB: 0, alarmCountC: 0 }
      groupAlarm = {
        ...alarm,
        color: (groupAlarm.color === 'red' ? 'red' : topColor(groupAlarm.color, alarm.color)),
        alarmCount: groupAlarm.alarmCount + alarm.alarmCount,
        alarmCountA: groupAlarm.alarmCountA + (alarm.type === 'A' ? alarm.alarmCount : 0),
        alarmCountB: groupAlarm.alarmCountB + (alarm.type === 'B' ? alarm.alarmCount : 0),
        alarmCountC: groupAlarm.alarmCountC + (alarm.type === 'C' ? alarm.alarmCount : 0),
        hasInfo: groupAlarm.hasInfo || alarm.hasInfo,
        lastAlarm: alarm.message,
        lastAlarmAt: alarm.alarmAt,
        firstAlarmAt: groupAlarm.firstAlarmAt || alarm.alarmAt
      }
      grouped[key] = groupAlarm
    })
    const alarms = []
    for (var key in grouped) {
      alarms.push(grouped[key])
    }
    return alarms.sort(sortByAlarmAt).sort(sortByColor)
  },

  byRealEstateAll: (state, getters) => (realEstate) => {
    return getters.all.filter(alarm => {
      return alarm.realEstateID === realEstate.id
    })
  },

  byRealEstateAndCategory: (state, getters) => (realEstate, categoryID) => {
    return getters.all.filter(alarm => {
      return alarm.realEstateID === realEstate.id && alarm.categoryID === categoryID
    })
  },

  byRealEstateAndSystem: (state, getters) => (realEstate, systemID) => {
    return getters.all.filter(alarm => {
      return alarm.realEstateID === realEstate.id && alarm.systemID === systemID
    })
  },
  byCategory: (state, getters) => (categoryID) => {
    return getters.all.filter(alarm => {
      return alarm.categoryID === categoryID
    })
  }
}

// actions
const actions = {

  async preloadAlarms ({ state, dispatch }) {
    if (!authorization.authorize()) return
    if (state.alarms.length > 0) return
    await dispatch('fetchAlarms')
  },

  async fetchAlarms ({ commit, dispatch }) {
    const res = await Vue.axios.get('/api/alarms/')
    if (res.status === 200) commit('setAlarms', res.data.alarms)
    await dispatch('issues/fetchIssues', null, {root: true})
  },

  async updateInfo ({ commit, dispatch }, val) {
    const res = await Vue.axios.post(`/api/alarms/${val.id}/note`, { note: val.text })
    if (res.status === 200) await dispatch('fetchAlarms')
  },

  async updateCase ({ commit, dispatch }, val) {
    const res = await Vue.axios.post(`/api/alarms/${val.id}/case`, val)
    if (res.status === 200) await dispatch('fetchAlarms')
  },

  async updateLinks ({ commit, dispatch }, val) {
    const res = await Vue.axios.post(`/api/alarms/${val.id}/links`, { links: val.links })
    if (res.status === 200) await dispatch('fetchAlarms')
  },

  async updateDedu ({ commit, dispatch }, val) {
    const res = await Vue.axios.post(`/api/alarms/${val.id}/dedu`, { deduID: val.deduID })
    if (res.status === 200) await dispatch('fetchAlarms')
  },

  async remove ({ commit, dispatch }, val) {
    const res = await Vue.axios.delete(`/api/alarms/${val.id}`)
    if (res.status === 200) {
      await dispatch('fetchAlarms')
      return true
    }
  },

  async removeMany ({ commit, dispatch }, val) {
    for (let i = 0; i < val.ids.length; i++) {
      await Vue.axios.delete(`/api/alarms/${val.ids[i]}`)
    }
    await dispatch('fetchAlarms')
    return true
  },

  async report ({ commit, dispatch }, val) {
    // TODO: should be it's own endpoint
    const res = await Vue.axios.post(`/api/alarms/${val.id}/note`, { note: val.text })
    if (res.status === 200) await dispatch('fetchAlarms')
  }
}

// mutations
const mutations = {

  setAlarms (state, alarms) {
    // info field is now used as comments in json, this below we do to be backward compatible
    let parsedAlarms = alarms.map(alarm => {
      alarm.comments = []
      if (alarm.info && typeof alarm.info === 'string') {
        if (alarm.info[0] === '{') {
          try {
            let parsedInfo = JSON.parse(alarm.info)
            alarm.comments = (parsedInfo.comments || [])
          } catch (e) {
            // most likely not json, no need to do anything about it now
          }
        } else {
          // convert last info to a comment
          alarm.comments.push({
            by: alarm.infoBy,
            byId: alarm.infoByAccountID,
            at: alarm.infoAt,
            text: alarm.info
          })
        }
      }
      return alarm
    })
    state.alarms = parsedAlarms.sort(sortByAlarmAt)
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/alarm.js